import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function Unauthorized() {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div id="notfound">
      <div className="notfound">
        <div className="notfound-404">
          <h1>
            4<span>0</span>3
          </h1>
        </div>
        <p>
          Sorry, your access is refused due to security reasons of our server
          and also our sensitive data. Please go back to the previous page to
          continue browsing.
        </p>
        <button
          type="button"
          className="btn btn-warning"
          onClick={() => {
            if (location?.state?.from) navigate(-1);
            else navigate('/');
          }}
        >
          Go Back!
        </button>
      </div>
    </div>
  );
}
